<template>
  <div class="layout">
    <a id="top" class="skip-to-content" href="#main">Skip to content</a>
    <header>
      <slot name="header" />
    </header>
    <main id="main">
      <Loader></Loader>
      <slot name="default" />
    </main>
  </div>
</template>
<script setup lang="ts">
import Loader from '../common/Loader.vue';
</script>
<style scoped>
.layout {
  min-height: 100vh;
}

main {
  padding-bottom: 56px;
  margin-bottom: 30px;
}
</style>
